import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface ToastMessage {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-container">
      @for (toast of toasts; track toast) {
        <div
          class="toast"
          [ngClass]="'toast-' + toast.type">
          <span>{{ toast.message }}</span>
          <button class="toast-close" (click)="removeToast(toast.id)">&times;</button>
        </div>
      }
    </div>
    `,
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
  toasts: ToastMessage[] = [];

  addToast(message: string, type: 'success' | 'error' | 'info' | 'warning' = 'info', duration: number = 5000) {
    const id = Date.now().toString();
    const toast: ToastMessage = { id, message, type, duration };
    
    this.toasts.push(toast);

    setTimeout(() => {
      this.removeToast(id);
    }, duration);
  }

  removeToast(id: string) {
    this.toasts = this.toasts.filter(toast => toast.id !== id);
  }
}